import { TabbedNavChoice } from "../TabbedNav";

export const DEFAULT_SEARCH_PAGE = "tags";

export const SEARCH_TAG_CHOICES: TabbedNavChoice[] = [
  { href: "../search-tags/tags", text: "Search Tags and Associations" },
  { href: "../search-tags/global", text: "Global Associations" },
];

export const GLOBAL_ASSOCIATIONS_QUERY_KEY =
  "/manager_new/module/global_associations/list";

export const SEARCH_TAGS_QUERY_KEY = "/manager_new/module/search_tags/list";
